// Clés d'accès des rôles 8000 proposées dans « Utilisateurs et rôles » et
// conversions de la page Mini-grid (partagé par UsersList et FormChangeUserRole).
export const PAGES = 
    [
        {value: "1000_Dashboard_Page", label: "Dashboard"},
        {value: '2000_Home_Page', label: 'Home' }, 
        {value: '3000_Entrer Paiement_Page', label: 'Entrer Paiement' },
        {value: '4000_Paiement_Page', label: 'Paiement' },
        // {value: "5000_Configuration_Page", label: "Configuration"}, admin Only
        // {value: "5500_Extract_Page", label: "Extract"},
        {value: "6000_Commercial_Page", label: "Commercial"},
        {value: "6500_Devis_Page", label: "Devis"},
        {value: "7000_Magasin_Page", label: "Magasin"},
        {value: "8000_Maintenance_Page", label: "Maintenance"},
        {value: "9000_Recouvrement_Page", label: "Recouvrement"},
        //{value: "10000_Production_Page", label: "Production"},
        //{value: "11000_Consommation_Page", label: "Consommation"},
        //{value: "12000_Financement_Page", label: "Financement"},
        //{value: "13000_Spendings_Page", label: "Dépenses"},
        // Niveau du rôle Mini-grid porté par ce rôle 8000 : il prime sur
        // l'assignation de la page Mini-grid « Rôles & accès » (domainModel
        // paygoRoleAppRole). Type _Minigrid : aucun menu créé (accessAction),
        // la page Mini-grid est ajoutée à l'enregistrement (toAccessPages).
        // Un seul niveau par rôle, cf. handleSelectPage.
        {value: "14010_viewer_Minigrid", label: "Mini-grid - Lecteur (viewer)"},
        {value: "14020_operator_Minigrid", label: "Mini-grid - Opérateur (operator)"},
        {value: "14030_editor_Minigrid", label: "Mini-grid - Éditeur (editor)"},
        {value: "14040_admin_Minigrid", label: "Mini-grid - Administrateur (admin)"},

        // { value : "1_stats_Config", label: "Config - Home"},
        { value : "2_abo_Config", label: "Config - Abonnements"},
        { value : "19_aboadmin_Config", label: "Config - Abonnements (admin)"},
        { value : "3_agent_Config", label: "Config - Commerciaux"},
        { value : "21_agentadmin_Config", label: "Config - Commerciaux (admin)"},
        { value : "4_schema_Config", label: "Config - Schémas"},
        { value : "5_sim_Config", label: "Config - Sim"},
        { value : "6_sms_Config", label: "Config - SMS"},
        { value : "20_smsadmin_Config", label: "Config - SMS (admin)"},
        { value : "7_alert_Config", label: "Config - Alerte"},
        { value : "8_box_Config", label: "Config - Systèmes et Box"},
        { value : "9_installer_Config", label: "Config -  Techniciens"},
        { value : "10_users_Config", label: "Config - Utilisateurs"},
        { value : "11_extract_Config", label: "Config - Extract"},
        { value : "12_upload_Config", label: "Config - Upload"},
        { value : "13_uploadstore_Config", label: "Config - Upload Magasin"},
        // { value : "14_credit_Config", label: "Config - Crédit"},
        // { value : "15_funding_Config", label: "Config - Financement"},
        // { value : "16_company_Config", label: "Config - Entreprise"},
        { value : "17_matching_Config", label: "Config - Match Produits"},
        // Clé de page (pas _Config) : c'est elle que domainModel et storehouse contrôlent.
        // Elle ouvre Configuration > Paramètres > Intégrations (cf. accessAction PAGE_TO_CONFIG).
        { value : "15000_Integrations_Page", label: "Config - Intégrations"},
        // { value : "18_codesuperadmin_Config", label: "Config - Code Superadmin"},
    ]
// clés des niveaux Mini-grid : un rôle n'en porte qu'une
export const isMinigridLevel = (key) => typeof key === "string" && key.endsWith("_Minigrid")
// Page Mini-grid (menu) : plus proposée seule, elle suit le niveau choisi.
const MINIGRID_PAGE_KEY = "14000_Mini-grid_Page"
const MINIGRID_VIEWER_KEY = "14010_viewer_Minigrid"
// clés enregistrées -> clés affichées : la page Mini-grid est masquée ; seule,
// sans niveau (rôles antérieurs aux niveaux), elle est remplacée par viewer.
export const toDisplayedKeys = (keys) => {
    const list = keys || []
    if (!list.includes(MINIGRID_PAGE_KEY)) { return list }
    const rest = list.filter(key => key !== MINIGRID_PAGE_KEY)
    return rest.some(isMinigridLevel) ? rest : [...rest, MINIGRID_VIEWER_KEY]
}
// pages choisies -> clés enregistrées : un niveau Mini-grid ouvre aussi la page.
export const toAccessPages = (pages) => {
    const keys = (pages || []).map(page => page.value).filter(key => key !== MINIGRID_PAGE_KEY)
    return keys.some(isMinigridLevel) ? [...keys, MINIGRID_PAGE_KEY] : keys
}

// correspondance clé (value) -> libellé, pour afficher les memes noms que le dropdown PAGES
const PAGE_LABEL = PAGES.reduce((acc, p) => { acc[p.value] = p.label; return acc; }, {});
export const pageLabel = (key) => PAGE_LABEL[key] || (key ? key.split("_")[1] : key) || key;
